<section id="wrapper">
    <div class="login-register" style="background-image:url(assets/images/background/login-register.jpg);">
        <div class="login-box card">
            <div class="card-body">


                <form [formGroup]="loginForm" class="form-horizontal form-material" id="loginform" (ngSubmit)="login()">
                    <div class="row justify-content-center">        
                      <div class="col-12">
                        <h3 *ngIf="!(domainService.logoUrl$ | async) && !(domainService.inCustomDomain$ | async)" class="box-title m-b-20"><img src="assets/images/favicon.png" width="50"/>Ingresar </h3>
                      </div>                
                        <img *ngIf="(domainService.logoUrl$ | async)" width="180" [src]="domainService.logoUrl$ | async"/>
                        <div class="col-12">
                          <h3 *ngIf="(domainService.logoUrl$ | async)" class="box-title m-b-20 text-center">Ingresar </h3>
                        </div>
                    </div>
                    <div class="form-group ">
                        <div class="col-xs-12">
                            <input formControlName="email" autocapitalize="off" autocorrect="off" class="form-control" type="text" required="" placeholder="Email"> </div>
                    </div>
                    <div class="form-group">
                        <div class="col-xs-12">
                            <input formControlName="password" autocapitalize="off" autocorrect="off" class="form-control" type="password" required="" placeholder="Contraseña"> </div>
                    </div>
                    <div class="form-group row">
                        <div class="col-md-12">
                                <a href="javascript:void(0)" data-target=".bs-example-modal-sm" data-toggle="modal" id="to-recover" class="text-dark pull-right"><i class="fa fa-lock m-r-5"></i> ¿Olvidaste tu contraseña?</a> 
                        </div>
                    </div>
                    <div class="form-group text-center">
                        <div class="col-xs-12 p-b-20">
                            <button [disabled]="!loginForm.valid" [ngStyle]="{backgroundColor : (domainService.customColor$ | async)}" class="btn btn-block btn-lg btn-info btn-rounded" type="submit">Ingresar</button>
                        </div>
                        <div *ngIf="campoNoValido('email')" class="text-danger">Revise su email</div>
                        <div *ngIf="campoNoValido('password')" class="text-danger">Debe ingresar un password</div>
                    </div>
                   
                    <div class="form-group m-b-0">
                        <div class="col-sm-12 text-center">
                            ¿No tienes una cuenta? <a [routerLink]="['/register']" class="text-info m-l-5"><b [ngStyle]="{color : (domainService.customColor$ | async)}">Regístrate</b></a>
                        </div>
                    </div>
                </form>
                
               
            </div>
        </div>
    </div>
</section>


<div class="modal fade bs-example-modal-sm" tabindex="-1" role="dialog" aria-labelledby="mySmallModalLabel" aria-hidden="true" style="display: none;">
    <div class="modal-dialog modal-sm">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title" id="mySmallModalLabel">Recuperar contraseña</h4>
                <button type="button" class="close" data-dismiss="modal" aria-hidden="true">×</button>
            </div>
            <div class="modal-body">
                <div class="form-group ">
                    <div class="col-xs-12">
                        <input [(ngModel)]="e" class="form-control" type="email" placeholder="Email">
                        <button [disabled]="e.length==0" [ngStyle]="{backgroundColor : (domainService.customColor$ | async)}" class="btn btn-block btn-lg btn-info btn-rounded m-t-20" type="submit" (click)="submitNewPassword()">Solicitar cambio</button>
                    </div>
                </div> 
            </div>
        </div>
        <!-- /.modal-content -->
    </div>
    <!-- /.modal-dialog -->
</div>
